export const firebaseConfig = {
  apiKey: 'AIzaSyDXc7rg4cmSGqO4vawLI8NLhMviXSe0YBQ',
  authDomain: 'optometry-academy.firebaseapp.com',
  projectId: 'optometry-academy',
  storageBucket: 'optometry-academy.firebasestorage.app',
  messagingSenderId: '470569798293',
  appId: '1:470569798293:web:a2083ef0377524adc5699c'
}
